/* Pat's Pet Kitchen pk.js v4: reveal, gallery, buy box, sticky bar.
   No dependencies, no Aurora internals. Keep this file ASCII only: write symbols such as the
   pound sign as \u escapes, so a copy-paste through the wrong text encoding can't corrupt prices. */
(function () {
  'use strict';
  if (window.__pkInit) return;
  window.__pkInit = true;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-pk-reveal]:not(.pk-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('pk-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var delay = e.target.getAttribute('data-pk-delay');
          if (delay) e.target.style.transitionDelay = delay + 'ms';
          e.target.classList.add('pk-in'); io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initMarquee() {
    document.querySelectorAll('.pk-marquee__track:not([data-pk-dup])').forEach(function (track) {
      track.setAttribute('data-pk-dup', '1'); track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  function initGallery() {
    document.querySelectorAll('.pk-gallery').forEach(function (g) {
      var track = g.querySelector('.pk-gallery__track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('.pk-gallery__slide'));
      var dots = Array.prototype.slice.call(g.querySelectorAll('.pk-gallery__dot'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.pk-thumb'));
      function setActive(i) {
        dots.forEach(function (d, k) { d.classList.toggle('pk-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('pk-on', k === i); });
      }
      function goTo(i) { var s = slides[i]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); setActive(i); }
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth); setActive(Math.max(0, Math.min(slides.length - 1, i)));
        });
      }, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      g.querySelectorAll('[data-pk-gallery-prev]').forEach(function (b) { b.addEventListener('click', function () { goTo(Math.max(0, Math.round(track.scrollLeft / track.clientWidth) - 1)); }); });
      g.querySelectorAll('[data-pk-gallery-next]').forEach(function (b) { b.addEventListener('click', function () { goTo(Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth) + 1)); }); });
      setActive(0);
    });
  }

  function money(cents) { var v = cents / 100; return '\u00a3' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }

  function initBuyBox() {
    var box = document.querySelector('[data-pk-buybox]');
    if (!box) return;
    var data;
    try { data = JSON.parse(box.querySelector('[data-pk-product-json]').textContent); } catch (e) { return; }

    var state = {
      mode: box.getAttribute('data-pk-default-mode') || 'sub',
      size: parseInt(box.getAttribute('data-pk-default-plan') || '1', 10),
      qty: 1
    };
    var variant = data.variant, sizes = data.sizes;
    var plans = sizes.map(function (sd, i) {
      return data.plans.find(function (p) { return (p.name || '').indexOf('(' + sd.days + ' day') !== -1; }) || data.plans[Math.min(i, data.plans.length - 1)];
    });
    function plan() { return plans.length ? plans[Math.max(0, Math.min(plans.length - 1, state.size))] : null; }
    function subPrice(p) { return p ? (p.first || p.price) : variant.price; }
    function subOngoing(p) { return p ? (p.ongoing || p.price) : variant.price; }

    function render() {
      var p = plan(), sd = sizes[state.size] || sizes[0];
      box.querySelectorAll('.pk-size').forEach(function (el, i) {
        el.classList.toggle('pk-on', i === state.size);
        var pd = el.querySelector('[data-pk-pd]');
        if (pd && plans[i] && sizes[i] && sizes[i].days) pd.textContent = money(Math.round(subOngoing(plans[i]) / sizes[i].days)) + ' a day';
      });
      var sn = box.querySelector('[data-pk-size-name]'); if (sn && sd) sn.textContent = sd.label;
      box.querySelectorAll('.pk-opt').forEach(function (opt) { opt.classList.toggle('pk-opt--on', opt.getAttribute('data-pk-mode') === state.mode); });
      var subEl = box.querySelector('[data-pk-sub-price]'), subWas = box.querySelector('[data-pk-sub-was]'), subNext = box.querySelector('[data-pk-sub-next]');
      if (subEl && p) subEl.textContent = money(subPrice(p));
      if (subWas) subWas.textContent = money(variant.price);
      if (subNext && p) subNext.textContent = p.first && p.first !== p.ongoing ? 'then ' + money(subOngoing(p)) + ' every ' + sd.days + ' days' : 'every ' + sd.days + ' days';
      box.querySelectorAll('.pk-includes li span').forEach(function (el) {
        if (!el.hasAttribute('data-pk-tpl')) el.setAttribute('data-pk-tpl', el.textContent);
        var t = el.getAttribute('data-pk-tpl'); if (t.indexOf('{days}') > -1 && sd) el.textContent = t.replace('{days}', sd.days);
      });
      var perday = box.querySelector('[data-pk-sub-perday]');
      if (perday && p && sd) perday.textContent = money(Math.round(subOngoing(p) / sd.days)) + ' a day';
      var label, price;
      if (state.mode === 'sub') { label = box.getAttribute('data-pk-label-sub') || 'Add to cart'; price = subPrice(p); }
      else if (state.mode === 'pack3') { label = box.getAttribute('data-pk-label-pack3') || 'Add to cart'; price = variant.price * 2; }
      else { label = box.getAttribute('data-pk-label-one') || 'Add to cart'; price = variant.price; }
      price = price * state.qty;
      var q = box.querySelector('[data-pk-qty]'); if (q) q.textContent = state.qty;
      var dec = box.querySelector('[data-pk-qty-dec]'); if (dec) dec.disabled = state.qty <= 1;
      var l = box.querySelector('[data-pk-cta-label]'), pr = box.querySelector('[data-pk-cta-price]');
      if (l) l.textContent = label; if (pr) pr.textContent = money(price);
      var sc = document.querySelector('[data-pk-sticky-cta]'); if (sc) sc.textContent = label;
      var sp = document.querySelector('[data-pk-sticky-price]');
      var qs = state.qty > 1 ? ' \u00d7 ' + state.qty : '';
      if (sp) sp.textContent = money(price) + (state.mode === 'sub' ? ' \u00b7 ' + (sd ? sd.label : '') + ' dog subscription' + qs : state.mode === 'pack3' ? ' \u00b7 3 pouches' + qs : ' \u00b7 one pouch' + qs);
      var alt = box.querySelector('[data-pk-alt]');
      if (alt) alt.hidden = state.mode === 'one';
      var oneOpt = box.querySelector('.pk-opt[data-pk-mode="one"]');
      if (oneOpt) oneOpt.hidden = state.mode !== 'one';
    }

    box.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-pk-qty-inc]')) { state.qty = Math.min(10, state.qty + 1); render(); return; }
      if (ev.target.closest('[data-pk-qty-dec]')) { state.qty = Math.max(1, state.qty - 1); render(); return; }
      var head = ev.target.closest('.pk-opt__head');
      if (head) { state.mode = head.parentElement.getAttribute('data-pk-mode'); render(); return; }
      var size = ev.target.closest('.pk-size');
      if (size) { var idx = Array.prototype.indexOf.call(box.querySelectorAll('.pk-size'), size); if (idx > -1) { state.size = idx; if (state.mode === 'one') state.mode = 'sub'; render(); } return; }
      var one = ev.target.closest('[data-pk-choose-one]');
      if (one) { ev.preventDefault(); state.mode = 'one'; render(); }
    });

    function addToCart() {
      var btns = [box.querySelector('[data-pk-cta]'), document.querySelector('[data-pk-sticky-cta]')].filter(Boolean);
      btns.forEach(function (b) { b.setAttribute('disabled', ''); b.classList.add('pk-loading'); });
      var item = { id: variant.id, quantity: state.qty };
      if (state.mode === 'sub' && plan()) item.selling_plan = plan().id;
      if (state.mode === 'pack3') item.quantity = 3 * state.qty;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/cart'; })
        .catch(function () {
          btns.forEach(function (b) { b.removeAttribute('disabled'); b.classList.remove('pk-loading'); });
          var err = box.querySelector('[data-pk-error]'); if (err) err.hidden = false;
        });
    }
    var mainCta = box.querySelector('[data-pk-cta]'); if (mainCta) mainCta.addEventListener('click', addToCart);
    var stickyCta = document.querySelector('[data-pk-sticky-cta]'); if (stickyCta) stickyCta.addEventListener('click', addToCart);

    var sticky = document.querySelector('.pk-sticky');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('pk-show', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(mainCta);
    }
    render();
  }

  /* ---------- in-page links ("Read reviews", "Read all reviews", "Serving guide") ----------
     Links name a PK section id, but the editor can switch that section off or swap it for an app
     block: the PDPs replaced the PK Okendo section (#pk-reviews) with Okendo's own app block, which
     has no fixed id. Each link resolves through a fallback list at click time instead, so it finds
     the reviews wherever the Okendo block sits. One delegated listener survives editor re-renders. */
  var SCROLL_TARGETS = {
    '#pk-reviews': ['#pk-reviews', '[data-oke-widget][data-oke-reviews-product-id]', '[data-oke-reviews-widget]']
  };
  function scrollTarget(hash) {
    var list = SCROLL_TARGETS[hash] || [hash];
    for (var i = 0; i < list.length; i++) {
      var el = document.querySelector(list[i]);
      if (el && el.getClientRects().length) return el;
    }
    return null;
  }
  function scrollToTarget(t) {
    /* clear Aurora's header when its sticky setting is on; a small gap so the block isn't flush */
    function top() {
      var h = document.querySelector('.shopify-section-header');
      var off = h && /sticky|fixed/.test(getComputedStyle(h).position) ? h.offsetHeight : 0;
      return t.getBoundingClientRect().top + window.pageYOffset - off - 24;
    }
    window.scrollTo({ top: top(), behavior: 'smooth' });
    /* lazy images above the target can shift it mid-scroll: once the scroll settles, correct once,
       unless the visitor has started scrolling themselves (no scrollend event on older Safari) */
    var last = -1, still = 0, start = Date.now(), aborted = false, evs = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    function abort() { aborted = true; }
    evs.forEach(function (ev) { window.addEventListener(ev, abort, { passive: true }); });
    (function watch() {
      var y = window.pageYOffset; still = y === last ? still + 1 : 0; last = y;
      if (!aborted && still < 5 && Date.now() - start < 2500) { requestAnimationFrame(watch); return; }
      evs.forEach(function (ev) { window.removeEventListener(ev, abort); });
      if (!aborted && Math.abs(top() - y) > 8) window.scrollTo({ top: top(), behavior: 'smooth' });
    })();
  }
  function initAnchors() {
    if (window.__pkAnchors) return; window.__pkAnchors = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-pk-scroll]'); if (!a) return;
      var t = scrollTarget(a.getAttribute('href')); if (!t) return;
      e.preventDefault(); scrollToTarget(t);
    });
  }

  /* ---------- Aurora slider-grid: mouse drag-to-scroll in the mobile carousel layout ----------
     Aurora positions its carousel with translateX() for arrows/dots/mouse-swipes, while the
     mobile layout also scrolls natively (overflow-x: auto). A mouse "swipe" in the mobile layout
     (theme editor mobile view, responsive devtools) therefore translates the track AND clips it,
     leaving a sliver of the next slide. Real touch scrolls natively and is unaffected.
     Fix: in the mobile layout, mouse pointers drag the track's native scroll position, Aurora's
     mouse swipe handler is kept out of the loop, and any stale translateX is folded into scrollLeft. */
  function initAuroraTracks() {
    document.querySelectorAll('.slider-grid-track').forEach(function (track) {
      if (track.__pkDrag) return; track.__pkDrag = true;
      function mobileLayout() { var ox = getComputedStyle(track).overflowX; return ox === 'auto' || ox === 'scroll'; }
      function settle() {
        var m = /translateX\((-?[\d.]+)px\)/.exec(track.style.transform || '');
        if (m) { track.style.transform = ''; track.scrollLeft = track.scrollLeft + Math.abs(parseFloat(m[1])); }
      }
      var drag = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || !mobileLayout()) return;
        settle();
        drag = { x: e.clientX, left: track.scrollLeft, moved: false, id: e.pointerId };
        track.classList.add('pk-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerType !== 'mouse') return;
        var dx = e.clientX - drag.x;
        if (Math.abs(dx) > 3) drag.moved = true;
        track.scrollLeft = drag.left - dx;
      });
      function end(e) {
        if (!drag) return;
        var moved = drag.moved; drag = null;
        track.classList.remove('pk-dragging');
        if (moved) {
          /* land on the nearest slide, matching Aurora's snap points */
          var kids = Array.prototype.slice.call(track.children);
          var target = track.scrollLeft, best = null;
          kids.forEach(function (k) { var d = Math.abs(k.offsetLeft - target); if (best === null || d < best.d) best = { d: d, left: k.offsetLeft }; });
          if (best) track.scrollTo({ left: best.left, behavior: 'smooth' });
          var swallow = function (ev) { ev.stopPropagation(); ev.preventDefault(); track.removeEventListener('click', swallow, true); };
          track.addEventListener('click', swallow, true);
          setTimeout(function () { track.removeEventListener('click', swallow, true); }, 300);
        }
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      /* keep Aurora's mousedown/mouseup swipe logic out of the mobile layout */
      ['mousedown', 'mouseup'].forEach(function (type) {
        track.addEventListener(type, function (e) { if (mobileLayout()) e.stopPropagation(); });
      });
      /* a real finger: make sure no stale translateX offsets the native scroll */
      track.addEventListener('touchstart', settle, { passive: true });
    });
  }

  function boot() { initReveal(); initMarquee(); initGallery(); initBuyBox(); initAnchors(); initAuroraTracks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
